import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    approveFunc: PropTypes.func.isRequired,
    content: PropTypes.string.isRequired,
    rejectFunc: PropTypes.func,
    title: PropTypes.string,
    approveButtonName: PropTypes.string,
    rejectButtonName: PropTypes.string,
  },
  getInitialState() {
    return {
      isActive: false,
      fadeClassName: "modal-view-fade-in",
      scrollPos: 0,
    };
  },
  componentDidMount() {
    this._handle = 0;
  },
  componentWillUnmount() {
    clearTimeout(this._handle);
  },
  openModal() {
    var scrollPos = window.pageYOffset;
    var marginLeft =
      (window.innerWidth - $(".royal_preloader .container").outerWidth()) / 2;
    var width = window.innerWidth > 767 ? "" : "100%";
    $(document.body).css({
      position: "fixed",
      marginTop: -scrollPos,
      marginLeft: marginLeft,
      width: width,
    });
    this.setState({
      fadeClassName: "modal-view-fade-in",
      isActive: true,
      scrollPos: scrollPos,
    });
  },
  closeModal() {
    $(document.body).css({
      position: "relative",
      marginTop: "0",
      marginLeft: "0",
      width: "",
    });
    $(window).scrollTop(this.state.scrollPos);
    this.setState({
      fadeClassName: "modal-view-fade-out",
    });
    this._handle = setTimeout(
      function() {
        this.setState({
          isActive: false,
        });
      }.bind(this),
      300
    );
  },
  handleApproveButton() {
    this.props.approveFunc();
    this.closeModal();
  },
  handleRejectButton() {
    if (this.props.rejectFunc != undefined) {
      this.props.rejectFunc();
    }
    this.closeModal();
  },
  render() {
    if (!this.state.isActive) {
      return null;
    }
    var header = "";
    if (this.props.title) {
      header = (
        <div className="modal-view-header">
          <p style={{ margin: "0 0 6px", paddingTop: "1.5em" }}>
            <strong>{this.props.title}</strong>
          </p>
        </div>
      );
    }
    return (
      <div
        className="modal-view"
        style={{ position: "relative", zIndex: "10001" }}
      >
        <div className={this.state.fadeClassName}>
          <div className="modal-view-overAll">
            <div className="modal-view-overlay" />
            <div className="modal-view-dialog">
              <div className="modal-view-content">
                {header}
                <div
                  className="modal-view-body"
                  style={{ paddingBottom: "2em" }}
                >
                  <p>{this.props.content}</p>
                </div>
                <div className="modal-view-footer">
                  <a
                    className="modal-view-button-left-6"
                    onClick={this.handleRejectButton}
                  >
                    {this.props.rejectButtonName
                      ? this.props.rejectButtonName
                      : "キャンセル"}
                  </a>
                  <a
                    className="modal-view-button-right-6"
                    onClick={this.handleApproveButton}
                  >
                    {this.props.approveButtonName
                      ? this.props.approveButtonName
                      : "OK"}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
